const stopWords = new Set(['a','ad','al','alla','alle','allo','ai','agli','da','dal','dalla','dei','del','dell','della','delle','dello','di','e','ed','il','in','la','le','lo','per','con','un','una','uno']);
export function normalize(value: string) { return value.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase().replace(/[^a-z0-9]+/g,' ').trim().replace(/\s+/g,' '); }
export function tokens(value: string) { return normalize(value).split(' ').filter(t=>t&&!stopWords.has(t)); }
export function codeKey(value: string) { return value.toUpperCase().replace(/[.\s]/g,''); }
export function distance(a: string,b: string) {
  let previous=Array.from({length:b.length+1},(_,i)=>i);
  for(let i=1;i<=a.length;i++) {const row=[i];for(let j=1;j<=b.length;j++)row[j]=Math.min(row[j-1]+1,previous[j]+1,previous[j-1]+(a[i-1]===b[j-1]?0:1));previous=row;}
  return previous[b.length];
}
export const tolerance=(term:string)=>term.length<5?0:term.length<9?1:2;
